
export const getPopularKeywords = ({ popularKeywordsReducer: { popular_keywords = [] } = {} }) => popular_keywords;
export const getPopularKeywordFilter = ({ popularKeywordsReducer: { filter = {} } = {} }) => filter;
export const getPopularKeywordsCount = ({ popularKeywordsReducer: { count = 0 } = {} }) => count;
